module.exports = __webpack_public_path__ + "img/大型煤企产销协同管理实践—淮南矿业（集团）有限责任公司—1-1.e66a08e8.jpg";